export const Colors = {
    GREEN: 'green',
    RED: 'destructive'
}